import { Switch } from '@mui/material';
import { GREY, MAIN_THEME_COLOR } from '../assets/theme/Colors';

interface CustomSwitchProps {
	isChecked: boolean;
	handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function CustomSwitch({ isChecked, handleChange }: CustomSwitchProps) {
	return (
		<Switch
			checked={isChecked}
			onChange={handleChange}
			size="small"
			sx={{
				width: 36,
				height: 22,
				padding: 0,
				'& .MuiSwitch-switchBase': {
					padding: '3px',
					color: GREY,
					'&:hover': {
						backgroundColor: 'rgba(0, 0, 0, 0.08)',
					},
					'&.Mui-checked': {
						color: MAIN_THEME_COLOR,
						transform: 'translateX(14px)',
						'&:hover': {
							backgroundColor: 'rgba(0, 168, 132, 0.08)',
						},
					},
					'&.Mui-checked + .MuiSwitch-track': {
						backgroundColor: MAIN_THEME_COLOR,
					},
				},
				'& .MuiSwitch-track': {
					backgroundColor: '#E0E0E0',
					borderRadius: '11px',
				},
				'& .MuiSwitch-thumb': {
					width: 16,
					height: 16,
				},
			}}
		/>
	);
}

export default CustomSwitch;
